'use client'

import React from 'react'
import styles from './LargeFeatureText.module.scss'
import { ComponentProps } from '@/types/database'
import { AnimatedWords } from '@/components/AnimatedWords'

interface LargeFeatureTextProps extends ComponentProps {
  text1?: string
  text2?: string
  text3?: string
  noTopPadding?: boolean
  noBottomPadding?: boolean
}

export const LargeFeatureText: React.FC<LargeFeatureTextProps> = ({
  text1 = 'Gather Productions is a content production company',
  text2 = 'based in Aotearoa, New Zealand.',
  text3 = 'We bring together original ideas, great people and rock solid production to make stories worth watching.',
  noTopPadding = false,
  noBottomPadding = false
}) => {
  // Calculate animation delays for sequential animation
  const baseStaggerDelay = 0.05
  const baseDuration = 0.5
  
  // Estimate animation duration for each text block
  const getAnimationDuration = (text: string) => {
    const wordCount = text.split(/\s+/).length
    return wordCount * baseStaggerDelay + baseDuration
  }
  
  const text1Duration = getAnimationDuration(text1)
  const text2Duration = getAnimationDuration(text2)
  
  const text2Delay = text1Duration + 0.03 // Small gap between animations
  const text3Delay = text2Delay + text2Duration + 0.03

  return (
    <section className={styles['large-feature-text']}>
      <div className={`${styles['large-feature-text__container']} ${
        noTopPadding && noBottomPadding ? styles['large-feature-text__container--no-vertical'] :
        noTopPadding ? styles['large-feature-text__container--no-top'] :
        noBottomPadding ? styles['large-feature-text__container--no-bottom'] : ''
      }`}>
        {text1 && (
          <AnimatedWords
            text={text1}
            className={styles['large-feature-text__text']}
            as="h2"
            staggerDelay={baseStaggerDelay}
            animationDelay={0}
            duration={baseDuration}
          />
        )}
        
        {text2 && (
          <AnimatedWords
            text={text2}
            className={styles['large-feature-text__text']}
            as="h2"
            staggerDelay={baseStaggerDelay}
            animationDelay={text2Delay}
            duration={baseDuration}
          />
        )}
        
        {text3 && (
          <AnimatedWords
            text={text3}
            className={styles['large-feature-text__text']}
            as="h2"
            staggerDelay={baseStaggerDelay}
            animationDelay={text3Delay}
            duration={baseDuration}
          />
        )}
      </div>
    </section>
  )
} 